import handleToast from './handleToast'

// eventTaskUpdated(data, modelContext, toastsContext)
export default function eventTaskUpdated({ author, user, task }, { modal }, { toasts, toastsDispatch, updateToasts }) {
  
  if (author?.id === user?.id) return;  // Don't throw toast.
  
  const { dataset, datasetRef, dispatch, prop, update } = modal;
  
  if (task?.id !== datasetRef.current.id) return;  // Don't throw toast.

  handleToast({
    title: 'Task Updated', 
    message: `Task #${task?.id} was updated by ${author?.name} (${author?.email}).`,
    autohide: false, 
    label: 'Show Latest Version', 
    callback: () => {
      task.updated_at >= datasetRef.current.updated_at && update(dispatch, { [prop]: task });  // calling datasetRef.current so value is computed when the function is called
      // if a child model of Task is updated, the updated_at attribute of Task won't change
    },
  }, { toasts, toastsDispatch, updateToasts });
}